import { Button, Form, Modal } from 'antd';
import PropTypes from 'prop-types';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import AssetsDetailForm from '../../../views/AssetDetails/components/tabs/AssetsDetailForm';

export const ModalAddAssetToFinalCustomer = ({
  show,
  handleClose,
  assetTypeData,
  finalCustomerId,
  createAsset,
  updateAsset,
  enabledAssetType,
}) => {
  const [form] = Form.useForm();
  const { translate: t } = useDictionaryTranslation();

  const closeModal = ({ refreshData = false }) => {
    form.resetFields();
    handleClose(refreshData);
  };

  return (
    <Modal
      bodyStyle={{ padding: '12px 24px 12px 24px' }}
      destroyOnClose
      title={t('createAsset')}
      width="35%"
      open={show}
      onCancel={closeModal}
      footer={
        <div>
          <Button form="assetInfoForm" key="submit" htmlType="submit" type="primary">
            {t('save')}
          </Button>
        </div>
      }
    >
      <AssetsDetailForm
        basicInfoOnly
        onFinish={closeModal}
        idExtendedForm={assetTypeData?.idExtendedForm}
        assetTypeId={assetTypeData?._id}
        finalCustomerId={finalCustomerId}
        createAsset={createAsset}
        updateAssetFunction={updateAsset}
        enabledAssetType={enabledAssetType}
      />
    </Modal>
  );
};

ModalAddAssetToFinalCustomer.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  assetTypeData: PropTypes.object,
  finalCustomerId: PropTypes.string,
  createAsset: PropTypes.func,
  updateAsset: PropTypes.func,
  enabledAssetType: PropTypes.bool,
};
